import { render, staticRenderFns } from "./IconCommoUnmute.vue?vue&type=template&id=391b5a72"
import script from "./IconCommoUnmute.vue?vue&type=script&lang=js"
export * from "./IconCommoUnmute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports